<template>
  <div class="kdsitem">
    <div class="kdsitem__row" :class="{ completed }" @click="toggleItem">
      <div class="kdsitem__checkbox" v-if="!completed"></div>
      <svgicon src="icon/check-circle-full.svg" :width="24" :height="24" v-else></svgicon>
      <div class="kdsitem__text color big bold right">99</div>
      <div class="kdsitem__text big bold">Item name</div>
      <div class="kdsitem__status"></div>
    </div>
    <div class="kdsitem__row" :class="{ completed: completed || row.completed }" @click="toggle(row)" v-for="row in rows"
      :key="`modifier-${generateUUID()}`">
      <div class="kdsitem__checkbox" v-if="!(completed || row.completed)"></div>
      <svgicon src="icon/check-circle-full.svg" :width="24" :height="24" v-else></svgicon>
      <div class="kdsitem__text bold right">00</div>
      <div class="kdsitem__text">Modifier</div>
      <div class="kdsitem__status"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "KDSItem",
    data() {
      return {
        completed: false,
        rows: []
      };
    },
    mounted() {
      for (let i = 0; i < Math.floor(Math.random() * 5); i++) {
        this.rows.push({
          completed: false
        });
      }
    },
    methods: {
      toggle(row) {
        row.completed = !row.completed;
      },
      toggleItem() {
        this.completed = !this.completed;
        this.rows.forEach(row => {
          row.completed = this.completed;
        });
        this.$emit("completed", this.completed);
      },
      generateUUID() {
        return generateUUID();
      }
    }
  };
</script>

<style lang="scss" scoped>
.kdsitem__row {
  display: flex;
  align-items: center;
  font-size: 20px;
  cursor: pointer;

  &:not(:last-child) {
    margin-bottom: 20px;
  }

  .big {
    font-size: 24px;
  }

  .bold {
    font-weight: 900;
  }

  .color {
    color: var(--primary-color);
  }

  .right {
    text-align: right;
    width: 28px;
    margin-right: 10px;
  }

  &.completed {
    color: #BFBFBF;

    .color {
      color: #BFBFBF;
    }
  }

  .kdsitem__checkbox {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 3px solid #BFBFBF;
    margin-right: 20px;
  }

  .svgicon {
    margin-right: 20px;
    fill: #BFBFBF;
  }
}
</style>